import { defineStore } from 'pinia';
import { transactionListV2 } from '@/api/wallet';

function defaultState() {
  return {
    list: [],
    loading: false,
    finished: false,
    pageNum: 1,
    pageSize: 20,
    filter: 'all',
    assetKey: ''
  };
}

function createAssetKey({ symbol, contractAddress } = {}) {
  const safeSymbol = String(symbol || '').trim().toUpperCase();
  const safeContractAddress = String(contractAddress || '').trim().toLowerCase();
  return `${safeSymbol}__${safeContractAddress}`;
}

export const useWalletTokenDetailStore = defineStore('wallet-token-detail', {
  state: () => defaultState(),
  actions: {
    reset() {
      Object.assign(this, defaultState());
    },
    syncAssetKey(payload = {}) {
      const nextKey = createAssetKey(payload);
      if (this.assetKey !== nextKey) {
        this.list = [];
        this.loading = false;
        this.finished = false;
        this.pageNum = 1;
        this.assetKey = nextKey;
      }
    },
    setFilter(filter = 'all') {
      const nextFilter = String(filter || 'all');
      if (this.filter !== nextFilter) {
        this.filter = nextFilter;
        this.list = [];
        this.loading = false;
        this.finished = false;
        this.pageNum = 1;
      }
    },
    async fetchNext({ chainNum, address, contractAddress, reset = false } = {}, config = {}) {
      if (reset) {
        this.list = [];
        this.loading = false;
        this.finished = false;
        this.pageNum = 1;
      }

      if (this.loading || this.finished) {
        return this.list;
      }

      this.loading = true;
      try {
        const result = await transactionListV2({
          chainNum,
          address,
          contractAddress: contractAddress || null,
          type: this.filter === 'all' ? null : this.filter,
          pageNum: this.pageNum
        }, config);

        const rows = Array.isArray(result?.list) ? result.list : Array.isArray(result) ? result : [];
        this.list = this.pageNum === 1 ? rows : [...this.list, ...rows];
        this.finished = rows.length < this.pageSize;
        if (rows.length > 0) {
          this.pageNum += 1;
        }
        return this.list;
      } finally {
        this.loading = false;
      }
    }
  }
});
